import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/index.scss'  // 引入全局样式
import './element-ui'

Vue.config.productionTip = false

new Vue({
  router,  // 注入路由实例
  render: h => h(App),
  mounted() {
    const loadingElement = document.getElementById('loading');
    const appElement = document.getElementById('app');

    if (loadingElement && appElement) {
      // 初始状态：主应用透明
      appElement.style.opacity = '0';
      appElement.style.display = 'block';

      // 添加过渡效果
      loadingElement.style.transition = 'opacity 0.5s ease';
      appElement.style.transition = 'opacity 0.5s ease';

      // 触发重绘
      void loadingElement.offsetHeight;

      // 执行过渡
      loadingElement.style.opacity = '0';
      appElement.style.opacity = '1';

      // 动画结束后移除加载页
      setTimeout(() => {
        loadingElement.style.display = 'none';
      }, 500); // 与过渡时间一致
    }
  }
}).$mount('#app')
